export const renewalEnTranslation = {
  renewal: {
    steps: {
      choose: "Choose",
      term: "Lease term",
      next: "Next steps",
      moveOut: "Move-out notice",
      of: "Step {{current}} of {{total}}",
      back: "Back",
      continue: "Continue",
    },
    choice: {
      title: "Renew or move out",
      subtitle: "Are you renewing, or moving out?",
      renew: "Renew lease",
      renewDescription: "Keep your home and pick a new lease term.",
      moveOut: "Submit notice to vacate",
      moveOutDescription: "Tell us your move-out date and next steps.",
    },
    stub: {
      renewTitle: "Renew lease",
      renewBody:
        "Lease term selection and signing are coming soon. For now, return home or use the renewal request from your property team if you already have instructions.",
      moveOutTitle: "Notice to vacate",
      moveOutBody:
        "Self-service notice to vacate is coming soon. Please contact your property team if you need to give notice today.",
      backHome: "Back to home",
    },
    terms: {
      title: "Choose a lease term",
      subtitle: "Review your approved renewal lease terms and rates.",
      rentOnlyNote:
        "Amounts shown are monthly rent only. Other recurring items are not included in this comparison.",
      months_one: "{{count}} month",
      months_other: "{{count}} months",
      months: "{{count}} months",
      termLabel_one: "{{count}} Month Lease",
      termLabel_other: "{{count}} Month Lease",
      termLabel: "{{count}} Month Lease",
      colTerm: "Select lease term",
      colRent: "Rent",
      colDates: "Lease dates",
      perMonth: "/ mo",
      preferred: "Preferred",
      continue: "Continue",
      empty:
        "No renewal terms are available yet for your lease. Please contact your property team.",
      nextTitle: "Term selected",
      nextBody:
        "Your term is saved. Updating your household details and signing the renewal are coming next.",
    },
    banner: {
      selfServiceLink: "Get started",
    },
  },
};
